import { Form, Input, Radio, Space } from 'antd';
import { t } from 'i18next';
import StudyTaskTypeEnum, { studyTaskTypeKey } from '../../enums/StudyTaskTypeEnum';
import { RE_ASSESSMENT_OUTCOME_OPTIONS } from '../../enums/ReAssessmentEnums';

/** Açık görevler arasında yeniden değerlendirme var mı? */
export const hasOpenReAssessment = (tasks) =>
    !!tasks?.some(x => x.taskType === StudyTaskTypeEnum.RE_ASSESSMENT);

/** Onay modallarındaki açık görev kutusu — dört çağrı yerinde aynı görünüm. */
export function OpenTasksBox({ tasks }) {
    if (!tasks?.length) return null;

    return (
        <div style={{ marginBottom: 16, padding: 12, backgroundColor: '#fff7e6', borderRadius: 4, border: '1px solid #ffd591' }}>
            <strong>{t('Open Tasks')}:</strong>
            {tasks.map((task, idx) => (
                <div key={idx} style={{ marginTop: 8 }}>
                    <div style={{ fontWeight: 500 }}>{t(studyTaskTypeKey(task.taskType))}</div>
                    {task.description && <div style={{ fontSize: 12, color: '#666' }}>{task.description}</div>}
                </div>
            ))}
        </div>
    );
}

/**
 * Açık görevin kapanış açıklaması.
 *
 * Yeniden değerlendirmede serbest metin YOKTUR: sunucu açıklamanın iki sabit sonuçtan biri olmasını
 * doğruluyor (bkz. StudyTaskService.Resolve) ve filtre/istatistik bu metinlere göre sınıflandırıyor.
 * Diğer görev tiplerinde mevcut serbest metin davranışı korunur.
 *
 * NOT: seçimi yapan, raporu ONAYLAYAN kullanıcıdır — çoğu kurulumda atanan doktorun kendisi değil.
 * Onay akışının yetki modeli bilinçli olarak değiştirilmedi.
 */
export default function TaskResolutionField({ tasks }) {
    if (hasOpenReAssessment(tasks)) {
        return (
            <Form.Item
                name="description"
                label={t('Re-Assessment Result')}
                rules={[{ required: true, message: t('Please select the re-assessment result') }]}
            >
                <Radio.Group>
                    <Space direction="vertical">
                        {RE_ASSESSMENT_OUTCOME_OPTIONS.map(o => (
                            <Radio key={o.value} value={o.value}>{t(o.labelKey)}</Radio>
                        ))}
                    </Space>
                </Radio.Group>
            </Form.Item>
        );
    }

    return (
        <Form.Item
            name="description"
            label={t('Please explain how the open task(s) will be resolved')}
            rules={[{ required: true, message: t('Please enter description') }]}
        >
            <Input.TextArea rows={4} placeholder={t('Explain how you resolved or will handle the open task(s)')} />
        </Form.Item>
    );
}
